import { MARK_PATH, MARK_VIEWBOX, MARK_RATIO } from './logoPaths';
import './GtoConnectLockup.css';

/**
 * Локап продукта: знак GTO и слово CONNECT под ним.
 *
 * Брендбук (стр. 11) прямо разрешает подставлять в дескриптор другой текст
 * — «Технический отдел», «Отдел мультимедиа контента» и т.д. Название
 * продукта здесь занимает то же место, что и дескриптор в основной версии
 * логотипа, и повторяет его пластику: та же скруглённая форма, тот же
 * оптический вес.
 *
 * Знак — обведённый контур из брендбука, он не масштабируется по-разному
 * по осям и не искажается.
 */
export function GtoConnectLockup({ markHeight = 96 }: { markHeight?: number }) {
  return (
    <div
      className="lockup"
      style={{ '--mark-h': `${markHeight}px` } as React.CSSProperties}
      role="img"
      aria-label="GTO CONNECT"
    >
      <svg
        className="lockup__mark"
        viewBox={MARK_VIEWBOX}
        width={markHeight * MARK_RATIO}
        height={markHeight}
        aria-hidden
        focusable="false"
      >
        <path d={MARK_PATH} fill="currentColor" fillRule="evenodd" clipRule="evenodd" />
      </svg>

      <span className="lockup__word" aria-hidden>
        CONNECT
      </span>
    </div>
  );
}
